import {
	UnallocatedCargo,
	TEOSCargo,
	TotalQtyAndWeight,
	CARGO_TYPE_ID,
	TCargoEOS
} from '@types';

export const getTotalQuantityAndWeight = (cargos: UnallocatedCargo[] | TEOSCargo[] | TCargoEOS[], variant: number): TotalQtyAndWeight => {
	return cargos.reduce((accumulator: TotalQtyAndWeight, cargo: UnallocatedCargo | TEOSCargo | TCargoEOS) => {
		const palletsCount = variant === CARGO_TYPE_ID.Pallets ?
			(cargo as UnallocatedCargo).pallet_qty || (cargo as UnallocatedCargo).qty :
			(cargo as TEOSCargo).pallet_quantity;
		const palletsSpaces = (variant === CARGO_TYPE_ID.Pallets || variant === CARGO_TYPE_ID.Other) ?
			(cargo as UnallocatedCargo).qty :
			(cargo as TEOSCargo).pallet_space_quantity;
		const itemsQuantity = variant === CARGO_TYPE_ID.CustomItem ?
			(cargo as UnallocatedCargo).pallet_qty :
			0;
		accumulator.totalPallets += palletsCount;
		accumulator.totalQty += palletsSpaces;
		if (typeof accumulator.itemsQuantity === 'number') accumulator.itemsQuantity += itemsQuantity;
		accumulator.totalWeight += typeof cargo.total_weight === 'number'
			? cargo.total_weight
			: parseFloat(`${cargo.total_weight}`);

		return accumulator;
	}, {
		totalQty: 0,
		totalWeight: 0,
		totalPallets: 0,
		itemsQuantity: 0
	});
}
